import { Injectable } from '@angular/core';
import { AppSettings } from '../shared/App-Settings';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../core/authentication.service';
import { Observable, of, throwError } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';
import { ResponseDTO } from '../models/response-dto';
import { Packages } from '../models/packages';
import { LocalStorageService, LocalStorageKeyOptions } from '../core/local-storage.service';
import { SessionService, SessionKeyOptions } from '../core/session.service';
import { DatePipe } from '@angular/common';
import { Shipments } from '../models/shipments';
import { ShipmentFilterOption } from '../searchFilters/shipment-filter-option';

const apiUrl = AppSettings.API_BASE_URL + "api/";
const apiUrlShipment = AppSettings.API_BASE_URL + "api/Shipments/";
const apiUrlDirectShipment = AppSettings.API_BASE_URL + "api/DirectShipments/";

@Injectable({
  providedIn: 'root'
})
export class ShipmentService {

  constructor(private httpClient: HttpClient, private auth: AuthenticationService, private session: SessionService) { }

  private handleError<T>(operation = 'operation', result?: T) {
    let errorMsg = '';
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getShipments(currentPage: number, pageSize: number, order: string, sortby: string, ShipmentID: string = '', ShipmentDate: Date = null, status: string = '', franchiseId: number=null,searchKey:string=''): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'ShipmentsCollection';

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (ShipmentID) {
      url = url + '&ShipmentCode=' + btoa(ShipmentID);
    }
    if (ShipmentDate) {
      var pipe = new DatePipe('en-US');
      url = url + '&ShipmentDate=' + pipe.transform(ShipmentDate, "MM-dd-yyyy");
    }
    if (status) {
      url = url + '&Status=' + status;
    }
    if (franchiseId > 0) {
      url = url + '&FranchiseId=' + franchiseId;
    }
 
    if (searchKey) {
      url = url + '&SearchKey=' + searchKey;
    }
    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap(heroes => console.log('fetched shipments')),
      catchError(this.handleError('getShipments', []))
    );
  }

  franchiseeShipmentsCollection(currentPage: number, pageSize: number, order: string, sortby: string, ShipmentID: string = '', ShipmentDate: Date = null, status: string = '', franchiseId: number=null,searchKey:string=''): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'FranchiseeShipmentsCollection';

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (ShipmentID) {
      url = url + '&ShipmentCode=' + btoa(ShipmentID);
    }
    if (ShipmentDate) {
      var pipe = new DatePipe('en-US');
      url = url + '&ShipmentDate=' + pipe.transform(ShipmentDate, "MM-dd-yyyy");
    }
    if (status) {
      url = url + '&Status=' + status;
    }
    if (franchiseId > 0) {
      url = url + '&FranchiseId=' + franchiseId;
    }
 
    if (searchKey) {
      url = url + '&SearchKey=' + searchKey;
    }
    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap(heroes => console.log('fetched shipments')),
      catchError(this.handleError('getShipments', []))
    );
  }

  deleteShipment(ShipmentId: number) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'Shipments/' + ShipmentId;

    return this.httpClient.delete<any>(url, httpOptions).pipe(

      tap(heroes => console.log('delete Shipment')),
      catchError(this.handleError('Delete Shipment', []))
    );
  }

  AddShipment(shipment): Observable<Shipments> {
    let accessToken = this.auth.getAccessToken();
    // shipment.closingTime = shipment.closingTime.toLocaleString();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    //let url = this.config.get('BASE_API_URL') + 'messages';
    let url = `${apiUrl}` + 'shipments';
    return this.httpClient.post<Shipments>(url, shipment, httpOptions);
  }

  UpdateShipment(id, shipment): Observable<Shipments> {
    // shipment.closingTime = shipment.closingTime.toLocaleString();
    ///Date issue to resolve take 1 date previous
    
    shipment.shipmentDate = new Date(shipment.shipmentDate);
    shipment.shipmentDate = shipment.shipmentDate.toLocaleString();
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'shipments/' + `${id}`;
    return this.httpClient.put<Shipments>(url, shipment, httpOptions);
  }

  getShipmentById(id: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    const url = `${apiUrl}shipments/${id}`;

    return this.httpClient.get<any>(url, httpOptions);
  }

  getShipmentsByFilter(FranchiseId: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'shipmentList?';

    if (FranchiseId) {
      url = url + 'franchiseId=' + FranchiseId;
    }
    return this.httpClient.get<any>(url, httpOptions);
  }

  ShipTheBOL(id): Observable<any> {

    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}shipments/${id}/shipTheBol`;
    return this.httpClient.put<Shipments>(url, {}, httpOptions);
  }
  TestBG(id): Observable<any> {

    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${apiUrl}shipments/${id}/TestBgService`;
    return this.httpClient.put<Shipments>(url, {}, httpOptions);
  }
  sendInvoices(id: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}shipments/${id}/sendInvoice`;

    return this.httpClient.get<any>(url, httpOptions);
    
  }

  getSearchShipments(currentPage: number, pageSize: number, order: string, sortby: string, filter:ShipmentFilterOption): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}` + 'ShipmentsCollection';

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (filter.searchKey) {
      url = url + '&SearchKey=' + filter.searchKey;
    }
    return this.httpClient.get<any>(url, httpOptions).pipe(
      tap(heroes => console.log('fetched shipments')),
      catchError(this.handleError('getShipments', []))
    );
  }

  track(id){
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrlShipment}TrackById?id=${id}`;

    return this.httpClient.get<any>(url, httpOptions);
  }

  trackDirect(id){
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrlDirectShipment}${id}/Track`;

    return this.httpClient.get<any>(url, httpOptions);
  }
}
